import { IMapProps, MapView } from "../components/Mapview/MapView";

export default function Map(props: IMapProps) {
    return <MapView {...props} />
}
